var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1447_8514)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.03123 11.9647C1.02246 11.9674 1.0148 11.9729 1.00935 11.9803C1.00391 11.9877 1.00098 11.9967 1.00098 12.0059C1.00098 12.015 1.00391 12.024 1.00935 12.0314C1.0148 12.0388 1.02246 12.0443 1.03123 12.047L4.42489 14.2885L5.39675 9.71533L1.03123 11.9647Z",
    fill: "#E72511"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1426 9.71143H20.2805C20.2275 9.7147 20.1757 9.728 20.1277 9.75062L15.817 11.9686C15.7778 11.9686 15.7739 12.0235 15.817 12.0509L19.1519 14.2455C19.1976 14.2711 19.2485 14.2858 19.3008 14.2886H20.159C20.206 14.2886 20.21 14.2886 20.159 14.2455L16.7497 12.0039L21.1426 9.75062C21.1779 9.73102 21.174 9.71143 21.1426 9.71143Z",
    fill: "#F08300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2888 9.71094H13.3049L12.333 14.2881H18.3091C18.3562 14.2881 18.3601 14.2881 18.3091 14.245L14.9076 12.0034L19.2771 9.75013C19.3398 9.73053 19.3359 9.71094 19.2888 9.71094Z",
    fill: "#E72511"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9644 9.71094H22.1062C22.0531 9.7135 22.0011 9.72684 21.9533 9.75013L17.6427 11.9682C17.6035 11.9682 17.6035 12.023 17.6427 12.0504L20.9815 14.245C21.0256 14.271 21.0753 14.2857 21.1265 14.2881H21.9886C22.0317 14.2881 22.0395 14.2881 21.9886 14.245L18.5832 12.0034L22.9565 9.75013C23.0114 9.73053 23.0075 9.71094 22.9644 9.71094Z",
    fill: "#FABE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0265 6.71749H4.95029C4.61534 6.7013 4.28531 6.80299 4.01755 7.00488C3.7498 7.20678 3.56125 7.4961 3.48468 7.82258C3.4499 7.97771 3.46103 8.13961 3.5167 8.28852C3.57237 8.43743 3.67017 8.56693 3.79818 8.6612L8.85731 12L19.0461 6.75667C19.0736 6.73316 19.0696 6.71749 19.0265 6.71749Z",
    fill: "#E72511"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7927 17.2394L8.86106 12L2.38333 15.3427C2.21972 15.4286 2.0757 15.5474 1.96036 15.6918C1.84502 15.8361 1.76087 16.0028 1.71321 16.1813C1.57998 16.7887 1.92091 17.2825 2.70859 17.2825H16.7848C16.8319 17.2825 16.8318 17.2629 16.7927 17.2394Z",
    fill: "#E72511"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1447_8514"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 10.565,
    fill: "white",
    transform: "translate(1 6.71729)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24);
export default __webpack_public_path__ + "static/media/우체국-24.37e448cf557d5a2205918a9d155f9840.svg";
export { ForwardRef as ReactComponent };